import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/news/deflatory_token.png");
;
import(/* webpackMode: "eager" */ "/app/public/news/fuel_new_economy.webp");
;
import(/* webpackMode: "eager" */ "/app/public/news/listed_on_coinsph.webp");
;
import(/* webpackMode: "eager" */ "/app/public/news/step_jars.webp");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITFINES.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITGET.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BYBIT.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/CHAINGPT.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/COOKIE_DAO.webp");
;
import(/* webpackMode: "eager" */ "/app/public/partners/DMAIL.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/GOMINING.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/MORALIS.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/MYTHICAL.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR_AI.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/OKX.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/RUNGP.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/SUPERDAPP.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/SWEATCOIN.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/TECTUM.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/TRAVALA.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/UPLAND.svg");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_round.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_square.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweateconomy_logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/FloatingGetWallet/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/InstallSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/News/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/PhonesCarousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/SectionLink/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/TextReveal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/VisibilityTracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/WelcomeMovingFigure/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/WelcomeTokenSection/LandingZoneComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/WelcomeTokenSection/styles.module.css");
